module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("1.  Few Strangers, Fewer Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02"
    }
  }, [_vm._v("2.  Bad Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  Trail of Guilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Inmate #12673")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Charlestown State Prison, 1900–1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Seeking Freedom and Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Into Heaven and Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  We Believe He Is an Unsafe Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Let Me, for Once, Breathe Free Air")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  A Plea for Mercy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  Without a Backward Glance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0